import { Component, inject, OnInit } from '@angular/core';
import { DirectoryNumberRef, EndUser } from '../../shared/models/generated/ziroModels';
import { EndUserResource } from '../../shared/resources/end-user.resource';
import { ModalBodyClass } from '../modal-body';
import { ZiroFormConfig } from '../../forms/ziro-forms-models';
import { PromptModalComponent } from '../prompt-modal/prompt-modal.component';
import { ZiroFormStateService } from '../../forms/ziro-form-state.service';
import { ZiroSelectConfig } from '../../forms/fields/select/ziro-select.component';
import { Observable } from 'rxjs';
import { ZiroFormsModule } from '../../forms/ziro-forms.module';

@Component({
  selector: 'ziro-change-primary-extension-modal',
  templateUrl: './change-primary-extension.modal.component.html',
  standalone: true,
  imports: [ZiroFormsModule],
})
export class ChangePrimaryExtensionModalComponent extends ModalBodyClass implements OnInit {
  private endUserResource = inject(EndUserResource);
  private modalComponent = inject<PromptModalComponent<any>>(PromptModalComponent);
  protected _ziroFormStateService: ZiroFormStateService;

  protected formConfig: ZiroFormConfig;
  selectedExtension: string;
  passedCandidates: DirectoryNumberRef[];

  ngOnInit(): void {
    this.passedCandidates = this.modalComponent.modalViewProperties.candidates;
    const candidateExtensions = this.passedCandidates.map((candidate) => {
      return candidate.extension;
    });
    this.formConfig = {
      fields: {
        changePrimaryExtension: {
          dataAutomation: 'ziro-select-input',
          componentConfig: new ZiroSelectConfig({
            options: candidateExtensions,
            bindValue: 'extension',
            clearWithInput: true,
            hideClear: true,
          }),
          required: true,
        },
      },
      options: {
        columnClasses: {
          label: 'd-none',
          input: 'col-12',
        },
      },
    } as ZiroFormConfig;
  }

  submit(): Observable<DirectoryNumberRef> {
    this.selectedExtension = this.formData.changePrimaryExtension;
    const selectedDirectoryNumberRef = this.passedCandidates.find((extension) => {
      return extension.extension === this.selectedExtension;
    });
    return new Observable((subscriber) => {
      this.endUserResource
        .get(
          this.modalComponent.modalViewProperties.endUserResult.ref.id,
          this.modalComponent.modalViewProperties.endUserResult.ref.serverId,
        )
        .subscribe((endUser: EndUser) => {
          endUser.primaryExtension = selectedDirectoryNumberRef;
          this.endUserResource
            .put(endUser, this.modalComponent.modalViewProperties.endUserResult.ref.serverId)
            .subscribe(() => {
              subscriber.next(selectedDirectoryNumberRef);
              subscriber.complete();
            });
        });
    });
  }
}
